<template>
  <div class="reg-form-wrap">
    <div class="form">
      <div class="form-title">
        <h4>Регистрация</h4>
        <div class="descriprion">
          <span>Добро пожаловать!</span>
          <span>
            Зарегистрируйтесь, чтобы пользоваться
            всеми возможностями Фотти
          </span>
        </div>
      </div>
      <div class="input-group-wrap">
        <Inputs
          ref="user_phone"
          placeholder="Введите телефон"
          class="phone-input"
          name="user_phone"
          subholder="Телефон"
        ></Inputs>
      </div>
      <div class="submit-group">
        <div class="confirm-line">
          <label>
            <Inputs type="checkbox" name="confirm_terms" checked="false">
              <span slot="labelforcheckbox" class="label">Я на всё согласен</span>
            </Inputs>
          </label>
        </div>
        <div class="btn-wrap" @click="registration">
          <Buttons class="btn-primary">Зарегистрироваться</Buttons>
        </div>
        <!--<div class="or-line-wrap">
          <div class="or-line"></div>
        </div>
        <div class="social-reg-wrap">
          <Buttons class="btn-fb">
            <a
              href="https://www.facebook.com/v2.8/dialog/oauth?client_id=1357470747748293&redirect_uri=https://fotty.ru/api/user/v1/social/fb&response_type=code&state=https://fotty.ru/auth/registration/"
            >Фейсбук</a>
          </Buttons>
          <Buttons class="btn-vk">
            <a
              href="https://oauth.vk.com/authorize?client_id=7188111&redirect_uri=https://fotty.ru/api/user/v1/social/vk&response_type=code&state=https://fotty.ru/auth/registration/"
            >Вконтакте</a>
          </Buttons>
        </div>-->
        <div class="under-form">
          Уже есть аккаунт?
          <router-link to="/auth/login/">Войти</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Inputs from '@/components/basic/Input.vue'
  import Inputmask from 'inputmask'
  import UserService from '@/services/User.js'
  import { tokenMethods } from '@/library/lib'

  export default {
    name: 'RegForm',
    components: {
      Inputs
    },
    mounted: function () {
      this.$refs.user_phone.setAttr('autocomplete', 'off')
      this.$refs.user_phone.setAttr('pattern', '\\d*')
      this.$refs.user_phone.setAttr('inputmode', 'numeric')

      let im = new Inputmask({
          mask: '+7 999 999 99 99',
          placeholder: '+7 ___ ___ __ __'
        }),
        _inp = this.$refs.user_phone.getInput()
      im.mask(_inp)
      _inp.focus()

      if (this.$route.query.token) {
        tokenMethods.setToken(this.$route.query.token)

        this.$router.push({path: '/profile/'})
      }
    },
    updated() {
      console.log()
    },
    methods: {
      registration: function () {
        let is_complete = this.$refs.user_phone.getInput().inputmask.isComplete()
        if (!is_complete) return

        let phone = this.$refs.user_phone.getValue()

        this.$parent.user.phone = phone

        UserService.registration({phone: phone})
          .then(this.regComplete)
          .catch(error => {
            this.$parent.user.ttl = error.response.data.ttl
            this.$router.push({name: 'confirmation'})
          })
      },
      regComplete: function () {
        this.$router.push({name: 'confirmation'})
      }
    }
  }
</script>
